import { SentMessageId } from "@sp-crm/core";
import React from "react";
import {
    ConversationFeedBasicsFragment,
    ConversationThreadType,
} from "../../generated/graphql";
import { SentMessageDetail } from "./sent-detail";
import { SentMessageThread } from "./sent-message-thread";
import { SmsMessageThread } from "./sms-message-thread";

export interface ConversationFeedProps {
    feed: ConversationFeedBasicsFragment;
    showClient?: boolean;
    showCommunity?: boolean;
    initialThreadId?: string;
}

export const ConversationFeed: React.FC<ConversationFeedProps> = props => {
    const { feed, showClient, showCommunity, initialThreadId } = props;

    const [viewing, setViewing] = React.useState<SentMessageId | null>();
    const closeWindow = React.useCallback(() => setViewing(null), []);

    return (
        <div className="flex flex-col max-w-screen-lg">
            {viewing ? (
                <SentMessageDetail onDismiss={closeWindow} messageId={viewing} />
            ) : null}
            <div className="flow-root">
                <ul role="list">
                    {feed.threads.length === 0 ? (
                        <div className="text-center text-gray-500 py-8">
                            <em>No messages yet</em>
                        </div>
                    ) : (
                        feed.threads.map(t => {
                            if (t.type === ConversationThreadType.Email) {
                                return (
                                    <SentMessageThread
                                        key={t.id}
                                        thread={t}
                                        onView={setViewing}
                                        showClient={showClient}
                                        showCommunity={showCommunity}
                                    />
                                );
                            } else if (t.type === ConversationThreadType.Sms) {
                                return (
                                    <SmsMessageThread
                                        key={t.id}
                                        thread={t}
                                        initialThreadId={initialThreadId}
                                    />
                                );
                            } else {
                                return null;
                            }
                        })
                    )}
                </ul>
            </div>
        </div>
    );
};
